import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { endpoints } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

/**
 * Handles the Emergent Google OAuth callback.
 * When the browser lands at /admin#session_id=XYZ, this component:
 * 1. extracts the session_id from the URL fragment
 * 2. exchanges it with the backend
 * 3. refreshes AuthContext and navigates to /admin
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [status, setStatus] = useState("Signing you in…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    if (!session_id) {
      navigate("/admin", { replace: true });
      return;
    }

    (async () => {
      try {
        await endpoints.sessionExchange(session_id);
        // Clear fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        navigate("/admin", { replace: true });
      } catch (e) {
        setStatus("Authentication failed. Redirecting…");
        setTimeout(() => navigate("/admin", { replace: true }), 1200);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[var(--ink)] text-[var(--cream)] flex items-center justify-center">
      <div className="text-center">
        <div className="tag-mono mb-4" style={{ color: "rgba(250,250,247,0.6)" }}>
          [ Emergent Auth ]
        </div>
        <div className="font-serif text-3xl md:text-5xl" style={{ letterSpacing: "-0.03em", fontWeight: 700 }}>
          {status}
        </div>
        <div className="mt-8 w-40 h-[2px] bg-[rgba(250,250,247,0.15)] mx-auto overflow-hidden">
          <div className="h-full w-1/2 bg-[var(--molten)] animate-pulse" />
        </div>
      </div>
    </div>
  );
}
